export const ROUTES = {  
    MAIN_URL: "company/:companyId/project/:projectId/*",
    MAP_WRAPPER: "map",
    RESULTS: "results",
    RESULTS_COMPARE: "compare",
    RESULTS_SURVEY: 'survey',
    SITE_SETTINGS: 'site-settings',
    PLANNER: 'planner',    
  };